import { render, staticRenderFns } from "./CarrierInfoImg.vue?vue&type=template&id=05ef61c5&scoped=true&"
import script from "./CarrierInfoImg.vue?vue&type=script&lang=js&"
export * from "./CarrierInfoImg.vue?vue&type=script&lang=js&"
import style0 from "./CarrierInfoImg.vue?vue&type=style&index=0&id=05ef61c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ef61c5",
  null
  
)

export default component.exports